import Animation from '../class/Animation/Animation.js';
import Form from '../class/Form/Form.js';
export default class Router {
    static initialise() {
        Animation.create([
            {
                'ids': ['fade-in-home_hero'],
                'yTriggerPoint': -1000,
                'duration': 800,
            },
        ]);
        Router.initialiseContact('0');
        Router.initialiseContact('1');
        // const emblaNode = document.querySelector('.embla__viewport') as HTMLElement;
        // const embla = EmblaCarousel(emblaNode, {
        //     loop: false,
        //     startIndex: 1,
        //     align: 'center'
        // });
    }
    ;
    static initialiseContact(formId) {
        const formElement = document.querySelector(`[data-form="${formId}"]`);
        if (formElement == null)
            return;
        const errorMessage = formElement.querySelector('[data-form="error"]');
        const successMessage = formElement.querySelector('[data-form="success"]');
        const pendingMessage = formElement.querySelector('[data-form="pending"]');
        const textArea = formElement.querySelectorAll('textarea');
        textArea.forEach(element => {
            element.style.height = `${element.scrollHeight}px`;
            element.addEventListener('input', OnInput, false);
        });
        function OnInput() {
            this.style.height = 'auto';
            this.style.height = (this.scrollHeight) + 'px';
        }
        new Form({
            'id': formId,
            'route': '/data/hero_contact',
            'data': ['name', 'email', 'company', 'phone', 'message'],
            'recaptchaAction': 'hero_contact',
            'preRequestCallback': (formData) => Router.preRequestCallback(formData, errorMessage, successMessage, pendingMessage),
            'successCallback': () => Router.successCallback(successMessage, pendingMessage),
            'errorCallback': (response) => Router.errorCallback(response, errorMessage, pendingMessage),
        });
    }
    static preRequestCallback(formData, errorMessage, successMessage, pendingMessage) {
        Router.populateMessage(errorMessage, '');
        Router.populateMessage(successMessage, '');
        const emailRegularExpression = /\S+@\S+\.\S+/;
        const phoneRegularExpression = /^\+?(\d[\d-.() ]?){7,14}\d$/;
        if ((String(formData.name) == null) || (String(formData.name) == '')) {
            Router.populateMessage(errorMessage, 'Please provide a name.');
            return false;
        }
        if (!(emailRegularExpression.test(String(formData.email).toLowerCase()))) {
            Router.populateMessage(errorMessage, 'Please provide a valid email address.');
            return false;
        }
        if (formData.phone && !(phoneRegularExpression.test(String(formData.phone)))) {
            Router.populateMessage(errorMessage, 'Please provide a valid phone number.');
            return false;
        }
        Router.populateMessage(pendingMessage, 'Please wait, your message is being sent...');
        return true;
    }
    static successCallback(successMessage, pendingMessage) {
        Router.populateMessage(pendingMessage, '');
        window.dataLayer.push({ 'event': 'Form Submit' });
        Router.populateMessage(successMessage, 'Thank you! Your message has been sent.');
    }
    static errorCallback(response, errorMessage, pendingMessage) {
        Router.populateMessage(pendingMessage, '');
        Router.populateMessage(errorMessage, response.error);
    }
    static populateMessage(element, message) {
        element.innerText = message;
        if (message == '') {
            element.classList.remove('cf-s-margin_top-xs5');
            return;
        }
        element.classList.add('cf-s-margin_top-xs5');
    }
}
;
